"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.perPlanTableConf = void 0;
var constants_1 = require("containers/TableMaker/constants");
var formatters_1 = require("utils/formatters");
var InputDiscountValue_1 = __importDefault(require("./CellComponents/InputDiscountValue"));
var SelectMode_1 = __importDefault(require("./CellComponents/SelectMode"));
var // XL, LG, MD, SM, XS,
XL = constants_1.CellSize.XL, LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD;
var getClientPrice = function (item) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if (((_a = item.planDiscount) === null || _a === void 0 ? void 0 : _a.mode) === 'fixed_price') {
        return ((_b = item.planDiscount.fixedValue) === null || _b === void 0 ? void 0 : _b[item.currency]);
    }
    if (((_c = item.planDiscount) === null || _c === void 0 ? void 0 : _c.mode) === 'percent_discount') {
        return (1 - ((_e = (_d = item.planDiscount) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : 0)) * ((_g = (_f = item.rrp) === null || _f === void 0 ? void 0 : _f.monthly[item.currency]) !== null && _g !== void 0 ? _g : 0);
    }
    if (((_h = item.planDiscount) === null || _h === void 0 ? void 0 : _h.mode) === 'fixed_discount') {
        return ((_k = (_j = item.rrp) === null || _j === void 0 ? void 0 : _j.monthly[item.currency]) !== null && _k !== void 0 ? _k : 0) - ((_m = (_l = item.planDiscount.fixedValue) === null || _l === void 0 ? void 0 : _l[item.currency]) !== null && _m !== void 0 ? _m : 0);
    }
    return undefined;
};
var getDiscount = function (item) {
    var _a;
    var clientPrice = getClientPrice(item);
    var listPrice = (_a = item.rrp) === null || _a === void 0 ? void 0 : _a.monthly[item.currency];
    return clientPrice !== undefined && listPrice
        ? (listPrice - clientPrice) / listPrice
        : undefined;
};
exports.perPlanTableConf = {
    headersMap: {
        name: 'Plan',
    },
    headerTooltip: {
        matchLevel: {
            description: '**Match** indicates how closely the customer name matches the Stripe name',
        },
    },
    sortMapper: {
        stripeMigrationMatchLevel: Object.fromEntries(['multiple', 'notFound', 'weak', 'similar', 'strong', 'exact'].map(function (v, i) { return [v, i]; })),
    },
    extractors: {
        listPrice: function (item) { var _a; return (_a = item.rrp) === null || _a === void 0 ? void 0 : _a.monthly[item.currency]; },
        clientPrice: getClientPrice,
        discount: getDiscount,
    },
    cells: [
        { field: 'name', cell: { width: XL, growCell: true, offset: 'left' }, truncate: {} },
        { field: 'planDiscount.mode', cell: { width: XL, isFlexCenter: true }, renderComponent: SelectMode_1.default, stopPropagation: true },
        { field: 'planDiscount.value', cell: { width: LG, isFlexCenter: true }, renderComponent: InputDiscountValue_1.default },
        { field: 'listPrice', cell: { width: MD, textAlign: 'right' }, money: {} },
        {
            field: 'discount',
            cell: { width: MD, textAlign: 'right' },
            renderField: function (v) { return v !== undefined ? (0, formatters_1.formatPercentPrecise)(v) : undefined; },
        },
        { field: 'clientPrice', cell: { width: MD, textAlign: 'right' }, money: {} },
    ],
};
exports.default = exports.perPlanTableConf;
